// src/lib/i18n/date/to-date.ts

/** Every formatter accepts these inputs. bigint/number(<=1e12) = unix SECONDS. */
export type DateInput = bigint | number | Date | string;

/**
 * Normalize a timestamp to a native Date, reusing the project-wide heuristic:
 * - Date: used directly
 * - bigint: seconds
 * - number > 1e12: milliseconds; otherwise seconds (on-chain timestamps are seconds)
 * - string: "yyyy/MM/dd HH:mm:ss" (slashes → dashes for local parsing) or ISO
 */
export function toDate(input: DateInput): Date {
  if (input instanceof Date) return input;
  if (typeof input === "bigint") return new Date(Number(input) * 1000);
  if (typeof input === "string") return new Date(input.replace(/\//g, "-"));
  return input > 1e12 ? new Date(input) : new Date(input * 1000);
}
